import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Input, message, List, Button, Spin, Checkbox } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import DBService from '../../../utils/DBService'
import Utils from '../../../utils/Utils'
import PosPaymentModal from './PosPaymentModal'
import clientsSrc from '../../clients/clientsSrc'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import PosSrc from '../PosSrc'
import { Context } from '../../../context'

function PosPaymentQuotation(props) {
  const [state] = useContext(Context)
  const [clientName, setClientName] = useState('')
  const [nit, setNit] = useState(null)
  const [cf, setCf] = useState(false)
  const [address, setAddress] = useState(null)
  const [phone, setPhone] = useState(null)
  const [email, setEmail] = useState(null)
  const [clientsList, setClientsList] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)
  const [visible, setVisible] = useState(null)
  const [clienteExoneradoCheck, setClienteExoneradoCheck] = useState(false)
  const [clienteExonerado, setClienteExonerado] = useState('')
  const initDataSource = JSON.stringify([{ id: 1, note: '' }])
  const [dataSource, setDataSource] = useState(JSON.parse(initDataSource))
  const [expirationDate, setExpirationDate] = useState(props.quotationData.day ? props.quotationData.day : '')

  useEffect(() => {
    if (props.quotationData?.notes && JSON.parse(props.quotationData?.notes).length > 0) {
      const data = JSON.parse(props.quotationData?.notes).map((p, i) => {
        const obj = {
          id: i,
          note: p
        }
        return obj
      })
      setDataSource(data)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (props.saveSell) {
      let validate = true

      let items = []
      if (props.quotationData?.products && props.quotationData.products.length > 0) {

        items = props.productsList.map(p => {
          if (!p.product) return null
          return {
            id: p.product,
            quote_id: p.quote_id,
            status: p.status,
            notes: p.notes,
            quantity: parseFloat(p.units),
            unit_price: parseFloat(p.price),
            type: p.type,
            discount_id: p.discount_id,
            discount_amount: p.discount_amount
          }
        })

      } else {
        items = props.productsList.map(p => {
          if (!p.product) return null
          return {
            id: p.product,
            quote_id: p.quote_id,
            status: p.status,
            notes: p.notes,
            quantity: parseFloat(p.units),
            unit_price: parseFloat(p.price),
            type: p.type,
            discount_id: p.discount_id,
            discount_amount: p.discount_amount
          }
        })
      }

      const notes = dataSource.map((item) => {
        return item.note;
      });

      let data = {
        store_id: props.store.id,
        store_turn_id: state.turn.id,
        name: clientName,
        nit: nit,
        address: address,
        phone: phone,
        email: email,
        items: items.filter(i => i),
        expiration_date: expirationDate,
        notes: notes,
        id: props.quotationData.quote_id ? props.quotationData.quote_id : null,
        status: props.quotationData.status ? props.quotationData.status : null,
        exonerated_client: clienteExoneradoCheck,
        municipality_ticket_code: clienteExonerado
      }
      props.closeQuote(data, validate)
    } else {
      props.sellUnsaved && props.sellUnsaved()
    }
    // eslint-disable-next-line
  }, [props.saveSell])

  useEffect(() => {
    setClientInputsToCF()
    // eslint-disable-next-line
  }, [])

  const searchByNit = e => {
    if ((e.key === 'Enter' || e === 'searchButton') && nit?.toLowerCase() !== 'cf') {
      if (!Utils.validateNit(nit)) return message.warning('Ingrese un NIT valido')
      setLoadingClients(true)

      clientsSrc
        .clientOptions({ nit })
        .then(async response => {
          if (response === 'Unauthenticated.') throw new Error('Unauthenticated')
          if (response.errors?.message[0] === 'Error de conexion') {
            let _clients = await DBService.getAll('clients')
            let client = _clients.filter(c => c.nit?.toLowerCase() === nit?.toLowerCase())
            if (client.length === 0) {
              setAddress(null)
              setPhone(null)
              setEmail(null)
              setClientName('')
              setLoadingClients(false)
              return message.warning('El NIT que ingreso no se encuentra registrado')
            } else {
              const { address, name, companies } = client[0]
              setAddress(address)
              setPhone((companies[0] && companies[0]?.pivot?.phone) || null)
              setEmail((companies[0] && companies[0]?.pivot?.email) || null)
              setClientName(name)
            }
          } else {
            if (!response.data || !response.data.data || response.data.data.length === 0) {
              setAddress(null)
              setPhone(null)
              setEmail(null)
              setClientName('')
              setLoadingClients(false)
              return message.warning('El NIT que ingreso no se encuentra registrado')
            }

            const { address, name, companies } = response.data.data[0]
            setAddress(address)
            setPhone((companies[0] && companies[0]?.pivot?.phone) || null)
            setEmail((companies[0] && companies[0]?.pivot?.email) || null)
            setClientName(name)
          }
          setLoadingClients(false)
        })
        .catch(e => {
          console.log(e)
          message.error('No se ha podido cargar la información del cliente.')
          setLoadingClients(false)
        })
    }
  }

  const SearchButton = <SearchOutlined className="search-addon-after" onClick={e => searchByNit('searchButton')} />
  const LoadingSpinner = <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />

  const addClient = data => {
    setClientsList([...clientsList, data])
    setVisible(false)
  }

  const setClientInputsToCF = async () => {
    let posSrc = null

    try {
      posSrc = await PosSrc.getStore(props.store.id)
    } catch (error) {
      console.log(error);
    }

    if (!(props.total >= 10000 && posSrc.company.country.name === 'Honduras')) {
      setNit('CF')
      setClientName('Cliente final')
      setAddress('Ciudad')
      setCf(true)
    }
  }

  const resetClientInputs = () => {
    setClientName(null)
    setAddress(null)
    setCf(false)
  }

  const onAdd = () => {
    if (dataSource.length > 2) return

    setDataSource(prevState => {
      const sorted = prevState.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id + 1 })
      return [...sorted, newRow]
    })
  }

  const onDelete = (e, rowId) => {
    if (dataSource.length === 1) return

    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))
      return value
    })
  }

  const onSetNotes = (value, rowId) => {
    const newDataSource = dataSource.map(row => {
      if (row.id === rowId) {
        return Object.assign(row, { note: value })
      }
      return row
    })

    setDataSource(newDataSource)
  }

  return (
    <>
      <PosPaymentModal visible={visible} addClient={addClient} visibleStatus={status => setVisible(status)} />
      <h4 className={'section-space-list-bottom'}>{props.edit ? 'Pago de cuenta por cobrar' : 'Detalles de la cotizacion'}</h4>
      <Row gutter={16}>
        <Col sm={10}>
          <div className={'title-space-field'}>Fecha de expiracion</div>
          <Input
            value={expirationDate}
            onChange={e => setExpirationDate(e.target.value)}
            size={'large'}
            placeholder="Dias habiles"
            min={0}
            max={60}
            type={'number'}
          />
        </Col>
        <Col sm={2}>
          <div className="sell-divider"></div>
        </Col>
        <Col sm={10}>
          <Row gutter={16} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <div className={'title-space-field title-space-top pl-2'}>Cliente</div>
            <Checkbox disabled={cf} checked={clienteExoneradoCheck} onChange={e => setClienteExoneradoCheck(e.target.checked)}>Cliente exonerado</Checkbox>
            <Col sm={24} className={'client-info'}>
              <Input
                disabled={props.edit}
                onKeyDown={searchByNit}
                addonAfter={loadingClients ? LoadingSpinner : SearchButton}
                onChange={e => {
                  setNit(e.target.value)
                  if (e.target.value.toLowerCase() === 'cf') {
                    setClientInputsToCF()
                  } else {
                    resetClientInputs()
                  }
                }}
                value={nit}
                placeholder={'NIT (presiona enter para buscar)'}
                size={'large'}
              />
              <Input
                disabled={props.edit || cf}
                value={clientName}
                onChange={e => setClientName(e.target.value)}
                placeholder={'Nombre cliente'}
                size={'large'}
              />
              <Input
                disabled={props.edit || cf}
                value={address}
                onChange={e => setAddress(e.target.value)}
                placeholder={'Dirección'}
                size={'large'}
              />
              <Input disabled={props.edit || cf} value={phone} onChange={e => setPhone(e.target.value)} placeholder={'Teléfono'} size={'large'} />
              <Input
                disabled={props.edit || cf}
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={'Correo electrónico'}
                size={'large'}
              />
              <Input
                disabled={(props.edit || cf || !clienteExoneradoCheck)}
                value={clienteExonerado}
                onChange={e => setClienteExonerado(e.target.value)}
                placeholder={'Cliente exonerado'}
                size={'large'}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className={'title-space-field'}>Notas:</div>
          <List
            id={'inventory-list'}
            size="large"
            rowKey="id"
            dataSource={dataSource}
            renderItem={(row, i) => (
              <List.Item>
                <Row gutter={16} align="bottom" className={'section-space-field w-100'} key={row.id}>
                  <Col sm={1}>
                    <div className={'title-space-bottom text-bold'}>{i + 1}</div>
                  </Col>
                  <Col sm={20}>
                    <Input value={row.note} onChange={e => onSetNotes(e.target.value, row.id)} placeholder={'Escribir Notas'} size={'large'} />
                  </Col>
                  <Col sm={3} className={'center-flex-div'}>
                    <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                      Eliminar
                    </Button>
                  </Col>
                </Row>
              </List.Item>
            )}
            footer={
              <Row gutter={16} className={'section-space-field'}>
                <Col sm={1}></Col>
                <Col sm={9}>
                  <div className="title-tendero dashed-border-button" onClick={onAdd}>
                    <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                      <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                    </svg>
                    <span className={'text'}>Agregar Nota</span>
                  </div>
                </Col>
              </Row>
            }
          />
        </Col>
      </Row>
    </>
  )
}

export default PosPaymentQuotation
